import { useTranslation } from "react-i18next";
import { useSelectShippingRateMutation } from "../api/cartApi";
import { useMutationWithFeedback } from "../../../../common/hooks/hooks";

/**
 * A custom hook to encapsulate the logic for selecting a shipping rate.
 */
export const useSelectShippingRate = () => {
  const { t } = useTranslation();
  const [selectShippingRateMutation, mutationResult] =
    useSelectShippingRateMutation();

  const { trigger, isLoading: isSelectingRate } = useMutationWithFeedback({
    mutation: [selectShippingRateMutation, mutationResult],
    errorMessages: {
      default: t(
        "feedback.cart.shippingRate.selectShippingRateError",
        "Failed to apply shipping rate. Please try again."
      ),
    },
  });

  const handleSelectShippingRate = trigger;

  return { handleSelectShippingRate, isSelectingRate };
};
